import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import '../assets/stylesheets/reset.scss'
import '../assets/stylesheets/grid.scss'
import '../assets/stylesheets/flex-image-grid.scss'
import '../assets/stylesheets/formatting.scss'
import favicon from '../assets/images/favicon.png'
import LeftNavigation from '../components/common/left-navigation.js'
import Footer from '../components/common/footer.js'
import { NavBarBackgroundImage } from '../components/shared-page-components/styled-components.js'

const LayoutMetaContent = () => (
  <Helmet>
    <meta charSet="utf-8" />
    <meta name="geo.position" content="37.777448; -122.411530" />
    <meta name="geo.placename" content="Airlift - Global Headquarters" />
    <meta name="og:site_name" content="Airlift" />
    <meta name="og:latitude" content="37.777448" />
    <meta name="og:longitude" content="-122.411530" />
    <meta name="og:street-address" content="666 Natoma Street" />
    <meta name="og:locality" content="San Francisco" />
    <meta name="og:region" content="CA" />
    <meta name="og:postal-code" content="94103" />
    <meta name="og:country-name" content="USA" />
    <meta
      name="keywords"
      content="airlift, san francisco, sf, california, ca, creative, studio, agency, firm, design, branding, identity, strategy, digital, physical, experience, ui, ux"
    />
    <link rel="shortcut icon" href={favicon} />
    <link rel="canonical" href={`${process.env.GATSBY_SITE_BASE_URL}`} />
  </Helmet>
)

const Layout = ({ children, data, location }) => {
  const projectLinks =
    data.allContentfulGlobalNavigation.edges[0].node.projectLinks

  const arrayOfCaseStudiesNodes = data.allContentfulCaseStudies.edges

  let backgroundColor
  let primaryTextColor
  let secondaryTextColor
  let navigationBarBackgroundImageUrl

  if (location.pathname.includes('/case-study/')) {
    let slugFromPathname = location.pathname.split('/')[2]

    const matchingNode = arrayOfCaseStudiesNodes.find(n => {
      return n.node.slug === slugFromPathname
    })

    if (matchingNode) {
      navigationBarBackgroundImageUrl =
        matchingNode.node.navigationBarBackgroundImage.file.url
      backgroundColor = matchingNode.node.caseStudyBackgroundColor
      primaryTextColor = matchingNode.node.caseStudyPrimaryColor
      secondaryTextColor = matchingNode.node.caseStudySecondaryColor
    }
  }

  if (location.pathname === '/') {
    navigationBarBackgroundImageUrl =
      data.contentfulHomePage.navigationBarBackgroundImage.file.url
    backgroundColor = data.contentfulHomePage.homePageBackgroundColor
    primaryTextColor = data.contentfulHomePage.homePagePrimaryColor
    secondaryTextColor = data.contentfulHomePage.homePageSecondaryColor
  }

  if (location.pathname === '/studio') {
    navigationBarBackgroundImageUrl =
      data.contentfulAboutPage.navigationBarBackgroundImage.file.url
    backgroundColor = data.contentfulAboutPage.aboutPageBackgroundColor
    primaryTextColor = data.contentfulAboutPage.aboutPagePrimaryColor
    secondaryTextColor = data.contentfulAboutPage.aboutPageSecondaryColor
  }

  return (
    <div style={{ position: 'relative' }}>
      <LayoutMetaContent />
      <LeftNavigation
        projectLinks={projectLinks}
        pathname={location.pathname}
      />
      <div>{children()}</div>
      <Footer
        footerData={data.allContentfulFooter.edges[0].node}
        backgroundColor={backgroundColor}
        primaryTextColor={primaryTextColor}
        secondaryTextColor={secondaryTextColor}
      />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
    contentfulHomePage(title: { eq: "Home Page - Master" }) {
      homePageBackgroundColor
      homePagePrimaryColor
      homePageSecondaryColor
      navigationBarBackgroundImage {
        file {
          url
        }
      }
    }
    contentfulAboutPage(pageTitle: { eq: "About Page - Master" }) {
      aboutPageBackgroundColor
      aboutPagePrimaryColor
      aboutPageSecondaryColor
      navigationBarBackgroundImage {
        file {
          url
        }
      }
    }
    allContentfulCaseStudies(limit: 100) {
      edges {
        node {
          slug
          caseStudyBackgroundColor
          caseStudyPrimaryColor
          caseStudySecondaryColor
          navigationBarBackgroundImage {
            file {
              url
            }
          }
        }
      }
    }
    allContentfulGlobalNavigation(limit: 1) {
      edges {
        node {
          projectLinks {
            slug
            displayTitle
            navigationDisplayTitle
          }
        }
      }
    }
    allContentfulFooter(limit: 1) {
      edges {
        node {
          rowOneLeftColumn {
            rowOneLeftColumn
          }
          rowOneRightColumn {
            rowOneRightColumn
          }
          rowTwoLeftColumn {
            rowTwoLeftColumn
          }
          rowTwoRightColumn {
            rowTwoRightColumn
          }
          rowThreeLeftColumn {
            rowThreeLeftColumn
          }
          rowThreeRightColumn {
            rowThreeRightColumn
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js